import { render, staticRenderFns } from "./configManageDriveAdmin.vue?vue&type=template&id=588fd58e&scoped=true"
import script from "./configManageDriveAdmin.vue?vue&type=script&lang=js"
export * from "./configManageDriveAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588fd58e",
  null
  
)

export default component.exports